<template>
    <b-modal title="Add User" no-close-on-backdrop hide-footer size="md" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="addContact">
            <div class="container custom_modal_body">
                <div class="form-group row">
                    <label for="inputRole" class="col-sm-4 col-form-label">Role <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <select name="role_id" v-validate="'required'"  v-model="newContact.role_id" id="inputRole" class="form-control" >
                            <option value="" >Select Role</option>
                            <option v-for="(user_role,index) in user_roles" :key="index" :value="user_role.id">{{user_role.name}}</option>
                        </select>
                        <p v-show="errors.has('role_id')"  style="color:red">* This Role Field is required</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputName" class="col-sm-4 col-form-label">Name <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <input name="Name" v-validate="'required'"   type="text"  v-model="newContact.name" id="inputName" class="form-control" placeholder="Name">
                        <p v-show="errors.has('Name')"  style="color:red">* {{ errors.first('Name') }}</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail" class="col-sm-4 col-form-label">Email <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <input @keydown="errorClear('email')" type="text" v-validate="'required|email'" data-vv-as="email" name="email"  v-model="newContact.email" class="form-control" id="inputEmail" placeholder="Email">
                        <p v-show="errors.has('email')"  style="color:red">* {{ errors.first('email') }}</p>
                        <p style="color:red" v-if="servererrors"><span v-for="(error,key) in servererrors.email" :key="key"><span style="color:red">*{{error}}</span></span></p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label for="inputPassword" class="col-sm-4 col-form-label">Password <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <input type="password" name="password" v-validate="'required'" v-model="newContact.password" class="form-control" id="inputPassword" placeholder="Password">
                        <p v-show="errors.has('password')"  style="color:red">* {{ errors.first('password') }}</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputMobile" class="col-sm-4 col-form-label">Mobile Number</label>
                    <div class="col-sm-8">
                        <input type="text" @keypress="errorClear('mobile_number')"  v-validate="'required|numeric'" v-model="newContact.mobile_number" class="form-control" name="phone" placeholder="মোবাইল নম্বর">
                        <p v-show="errors.has('phone')"  style="color:red">* {{ errors.first('phone') }}</p>
                        <p style="color:red" v-if="servererrors"><span v-for="(error,key) in servererrors.mobile_number" :key="key"><span style="color:red">*{{error}}</span></span></p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label for="inputNID" class="col-sm-4 col-form-label">NID</label>
                    <div class="col-sm-8">
                        <input type="text" @keypress="errorClear('nid')"  v-validate="'required|numeric'" v-model="newContact.nid" class="form-control" name="nid" placeholder="এন.আই.ডি নম্বর">
                        <p v-show="errors.has('nid')"  style="color:red">* {{ errors.first('nid') }}</p>
                        <p  v-if="servererrors"><span v-for="(error,key) in servererrors.nid" :key="key"><span style="color:red">*{{error}}</span></span></p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label for="inputBirthday" class="col-sm-4 col-form-label">Birthday</label>
                    <div class="col-sm-8">
                        <input type="date" v-model="newContact.birthday" class="form-control" id="inputBirthday" placeholder="Birthday">
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-12">
                <input type="submit" value="submit" v-if="!addContactLoader"  class="btn btn-primary pull-right">
                <button v-if="! addContactLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                <button v-if="addContactLoader" class="btn btn-primary pull-right" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate)

import { ADD_CONTACT,ALL_DISTRICT ,ALL_SUBDISTRICT,OPEN_CONTACT_MODAL,CLOSE_CONTACT_MODAL,ALL_USER_ROLE,ALL_CONTACT} from "../../store/action.type"
import { ADD_CONTACT_LOADER} from "../../store/mutation.type"
import { mapState,mapGetters } from "vuex"
export default {
    data(){
        return{
            servererrors:'',
            largeModal:false,
            addContactLoader:false,
            newContact:{
                role_id:'',
                type:'1',
                name: '',
                mobile_number:'',
                email: '',
                nid:'',
                birthday:'',
                password:''
            },
        }
    },
    methods:{
        close(){
            this.largeModal = false
        },
        addContact () {
            this.$validator.validateAll().then( result =>{
                if(result){
                    var data = this.newContact
                    this.addContactLoader = true;
                    this.$store.dispatch('ADD_CONTACT',data)
                    .then(response=>{
                        this.addContactLoader=false;
                        this.largeModal = false
                    })
                    .catch(error=>{
                        this.addContactLoader=false;
                        this.servererrors = error.response.data.errors;
                    });
                }

            })

        },
        openModal(){
            this.largeModal = true
            this.newContact.name = ""
            this.newContact.nid = ""
            this.newContact.password = ""
            this.newContact.email = ""
            this.newContact.birthday = ""
            this.newContact.mobile_number = ""
            this.servererrors = ""
        },
        allRole(){
            this.$store.dispatch('ALL_USER_ROLE')
        },
        errorClear(fields)
        {
            delete this.servererrors[fields];
        },
    },
    mounted(){
        this.allRole()
    },
    computed:{
        ...mapGetters(["user_roles"])
    }

}
</script>

<style>
.custom_modal_body{
    overflow: auto;
}
.logo_upload{
    border: 1px solid #ccc;
    width: 100%;
    height: 90px;
    background: #eceef0;
    text-align: center;
    cursor: pointer;
}
.image_upload p{
    margin-top: 10px;
    font-size: 12px;
}

.image_upload i{
    font-size: 34px;
}
.removeImage{
   position: absolute;
    right: 13px;
    top:  14px;
    color: var(--white);
    border: 1px solid;
    border-radius: 25px;
    padding: 4px 8px;
    background-color: #fb1212f5;
    font-size: 10px;
    font-family: cursive;
}
.fitimage {
    width: 32%;
    height: 100%;
    -o-object-fit: contain;
    object-fit: contain;
    background-color: #e6e6ef;
}
</style>
